import { Component, OnInit, HostListener, OnDestroy } from '@angular/core';
import { StartFunctionResponseModel } from '../../../model/startFunctionResponseModel';
import { CompleteFunctionResponseModel } from '../../../model/completeFunctionResponseModel';
import { EntityLicenseModel } from '../../../model/entityLicenseModel';
import { Subscription } from 'rxjs';
import { StartFunctionService } from '../../../shared/utils/start-function.service';
import { Router } from '@angular/router';
import { StorageService } from '../../../shared/security/StorageService';
import { SeverEmploymentService } from '../sever-employment.service';
import * as $ from 'jquery';
import { SeverEmploymentResponseModel } from '../../../model/severEmploymentResponseModel';
import { WorkflowModel } from '../../../model/workflowModel';
import { ContentPageModel } from '../../../model/models';
import { PaymentService } from '../../../shared/payment/payment.service';
import { CurrentPageWatcherService } from '../../../shared/utils/CurrentPageWatcher';

@Component({
  selector: 'app-sever-employment-receipt',
  templateUrl: './sever-employment-receipt.component.html',
  styleUrls: ['./sever-employment-receipt.component.css']
})
export class SeverEmploymentReceiptComponent implements OnInit,OnDestroy {

  public now: Date = new Date();
  employmentInfo: EntityLicenseModel;
  completeFunctionResponse: CompleteFunctionResponseModel;
  startFunction: StartFunctionResponseModel;
  severEmploymentResponse: SeverEmploymentResponseModel;
  agree: boolean = false;
  severEmploymentInfoSubscription: Subscription;
  severEmploymentResponseSubsription: Subscription;
  severEmploymentAgreementSubsription: Subscription;
  severEmploymentCompleteSubscription: Subscription;
  workflow : WorkflowModel;
  receiptInfo : ContentPageModel = {};
  title: string ="";

  constructor(private severEmploymentService:SeverEmploymentService,
    private startFunctionService: StartFunctionService,
    private router: Router,
    private storageService: StorageService,
    private paymentService : PaymentService,
    private currentPageWatcher : CurrentPageWatcherService) {

    this.startFunction = this.storageService.getStartFunctionData();

    this.severEmploymentInfoSubscription = this.severEmploymentService.getNotifySeverEmploymentInformation().subscribe(data => {
      this.employmentInfo = data;
      console.log("Employment Info : " + this.employmentInfo);
    });

    this.severEmploymentResponseSubsription = this.severEmploymentService.getNotifySelectedEmployer().subscribe(data => {
      this.severEmploymentResponse = data;
      console.log("Sever Employment Response : " + this.severEmploymentResponse);
    });

    this.severEmploymentAgreementSubsription = this.severEmploymentService.getNotifySeverAgreement().subscribe(data => {
      this.agree = data;
      console.log("Agree : " + this.agree);
    });

    this.severEmploymentCompleteSubscription = this.severEmploymentService.getNotifyCompleteSeverEmployer().subscribe(data => {
      this.completeFunctionResponse = data;
      console.log("Complete Function Response : " + this.completeFunctionResponse);
    });
  }

  ngOnInit() {
    if(this.severEmploymentResponse == null){
      this.severEmploymentResponse = this.severEmploymentService.getSeverSelectedEmploymentData();
    }
    if(this.employmentInfo == null){
      this.employmentInfo = this.severEmploymentService.getEmploymentInfoData();
    }
    if(this.agree == null){
      this.agree = this.severEmploymentService.getAgreementData();
    }
    
    if(this.completeFunctionResponse != null){
      this.workflow = this.completeFunctionResponse.Workflow;
    }
    if(this.completeFunctionResponse == null &&  this.severEmploymentResponse!=null){
      this.workflow = this.severEmploymentResponse.Workflow;
    }
    if(this.completeFunctionResponse == null &&  this.severEmploymentResponse==null){
      this.workflow = this.startFunction.Workflow;
    }

    this.title= this.workflow.WorkflowDisplayName;
    this.currentPageWatcher.pageChanged().emit(this.title);
    if (this.completeFunctionResponse == null) {
      this.paymentService.getPaymentReceipt(this.workflow.WorkflowID).subscribe(response=>{
        console.log("get receipt response : ", response);
        this.receiptInfo = response;
        //test if payment step exist 
        //test if pay step is not yet checked
        if (this.startFunction.Workflow.Steps.filter(el => el.checked == false).length==2){
          //check pay step
          this.startFunctionService.getNotifyStepInProgress().emit(true);
        }
      });

    }
  }

  

  goBackHome() {
    this.router.navigate(['/home']);
  }

  ngOnDestroy(): void {
    this.severEmploymentInfoSubscription.unsubscribe();
    this.severEmploymentCompleteSubscription.unsubscribe();
    this.severEmploymentAgreementSubsription.unsubscribe();
    this.severEmploymentResponseSubsription.unsubscribe();

    if(this.severEmploymentService.getSeverSelectedEmploymentData() != null){
      this.severEmploymentService.clearSeverSelectedEmploymentData();
    }
    if(this.severEmploymentService.getEmploymentInfoData() != null){
      this.severEmploymentService.clearEmploymentInfoData();
    }
    if(this.severEmploymentService.getAgreementData() != null){
      this.severEmploymentService.clearAgreementData();
    }
      this.currentPageWatcher.clearUserMessage();
      this.currentPageWatcher.clearStepMessage();
  }

  printPage(){
    window.print();
  }

  //back browser button
  @HostListener('window:popstate', ['$event'])
  onPopState(event) {
    if (this.completeFunctionResponse == null) {
      this.router.navigate(["/severEmploymentPay"]).then(()=>{
        this.startFunctionService.getNotifyStepInProgress().emit(false);
        this.severEmploymentService.getNotifySelectedEmployer().emit(this.severEmploymentResponse);
        this.severEmploymentService.getNotifySeverEmploymentInformation().emit(this.employmentInfo);
        this.severEmploymentService.getNotifySeverAgreement().emit(this.agree);

      })
    }
    else{
      this.router.navigate(["/severEmploymentReview"]).then(()=>{
        this.startFunctionService.getNotifyStepInProgress().emit(false);
        this.severEmploymentService.getNotifySelectedEmployer().emit(this.severEmploymentResponse);
        this.severEmploymentService.getNotifySeverEmploymentInformation().emit(this.employmentInfo);
        this.severEmploymentService.getNotifySeverAgreement().emit(this.agree);
      
      })
    }
  }

 
}



// WEBPACK FOOTER //
// ./src/app/broker/sever-employment/sever-employment-receipt/sever-employment-receipt.component.ts